import React from "react"
import Navbar from "../components/navbar/navbar"
import Footer from "../components/footer/footer"

export default function About() {
  return (
    <div>
      <Navbar />
      <h1>Acerca de Academia Temple</h1>
      <p>Comunidad de programadores apasionados por la tecnología</p>
      <Footer />
    </div>
  )
}
